import { ActivityEntityName, JobItemCommandId, PurchaseOrder, StageItemDetail } from '@jms/model';
import { firstValueFrom } from 'rxjs';
import { EntityDataServiceRaw } from '@workbuddy/services/entities/entity.data.service.raw';
import type { EntityOperationRecordLoaderContext } from '@workbuddy/services/entities/entity.manifest.surface';
import type { JobItemDetailParams } from './job.item.detail.context';

/** Merges PO status onto the item so Approved orders can lock quantity/prices. GetItem only stamps the ref. */
export async function withPurchaseOrder(item: StageItemDetail, entityData: EntityDataServiceRaw): Promise<StageItemDetail> {

  const id = item.purchaseOrder?._id;
  if (!id) return item;
  try {
    const purchaseOrder = await firstValueFrom(entityData.getById<PurchaseOrder>(ActivityEntityName.PurchaseOrder, id));
    return purchaseOrder?.item
      ? { ...item, purchaseOrder: { ...item.purchaseOrder, ...purchaseOrder.item } }
      : item;
  } catch {
    return item;
  }
}

export async function loadJobItemDetailRecord(context: EntityOperationRecordLoaderContext): Promise<StageItemDetail | null> {

  const params = (context.params ?? {}) as JobItemDetailParams;
  const entityData = context.injector.get(EntityDataServiceRaw);

  try {
    const item = await firstValueFrom(entityData.executeCommand<StageItemDetail>(ActivityEntityName.JobItem, JobItemCommandId.GetItem, {
      itemId: context.id,
      jobId: params.jobId,
      stageId: params.stageId,
    }));
    if (!item) return null;
    return withPurchaseOrder(item, entityData);
  } catch {
    return null;
  }
}
